import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import Dropzone from "react-dropzone";

const stylesUse = makeStyles(theme => ({
    imageStyle: {
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
    },
    textShowExcel: {
        minHeight: 40,
        display: "flex",
        alignItems: "center",
        maxWidth: "100%",
        overflow: "auto",
        background: "#fafafe",
    },
}));

export default function UploadFileExel({
    previewExcelFiles = [],
    classContainer = "",
    classActions = "",
    onAcceptedFiles = () => {},
    handleExportTemplate = () => {},
    removeAll = () => {},
    multiple = false,
    maxFiles = 1,
    error = "",
}) {
    const classes = stylesUse();
    return (
        <div className={classContainer ? classContainer : "row"}>
            {/* actions upload */}
            <div className={classActions ? classActions : "col-12 mb-5"}>
                <Dropzone
                    onDrop={acceptedFiles => onAcceptedFiles(acceptedFiles)}
                    multiple={multiple}
                    maxFiles={maxFiles}
                    accept={{
                        "text/csv": [],
                        "application/vnd.ms-excel": [],
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
                    }}>
                    {({ getRootProps, getInputProps }) => (
                        <>
                            <div className="mb-2">
                                {previewExcelFiles?.length ? (
                                    previewExcelFiles.map((file, index) => (
                                        <div key={index} className={`border ${error && "border-danger"} rounded px-5 ${classes.textShowExcel}`}>
                                            {file.name}
                                        </div>
                                    ))
                                ) : (
                                    <div className={`border ${error && "border-danger"} rounded px-5 ${classes.textShowExcel}`}>{null}</div>
                                )}
                            </div>
                            <section className="d-flex align-items-center mb-2">
                                <input {...getInputProps()} />
                                <Button
                                    className="btn t-btn-green mr-2"
                                    component="span"
                                    onClick={handleExportTemplate}>
                                    <i className="fas fa-file-image mr-1" style={{ color: "inherit" }}></i>Export
                                    Template
                                </Button>
                                <Button {...getRootProps()} className="btn t-btn-primary mr-2" component="span">
                                    <i className="fas fa-file-image mr-1" style={{ color: "inherit" }}></i>Upload
                                </Button>
                                <Button className="btn t-btn-gray" component={"span"} onClick={removeAll}>
                                    <i className="fas fa-trash-alt mr-1" style={{ color: "inherit" }}></i>Remove
                                </Button>
                            </section>
                            <div className="text-danger">{error}</div>
                        </>
                    )}
                </Dropzone>
            </div>
        </div>
    );
}
